import { render } from "./SelectionComponent.vue?vue&type=template&id=3900be5a"
import script from "./SelectionComponent.vue?vue&type=script&lang=js"
export * from "./SelectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__